
import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon'

export const WarningIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} viewBox="0 0 47 47" fill="none" >
            <g clipPath="url(#clip0_267_161)">
                <path d="M19.4307 2.35221C21.2393 -0.784071 25.7607 -0.784071 27.5693 2.35221L36.9664 18.6478L46.3635 34.9434C48.172 38.0796 45.9113 42 42.2942 42H4.70585C1.08868 42 -1.17205 38.0796 0.636535 34.9434L10.0336 18.6478L19.4307 2.35221Z" fill="#FFEE2B" />
                <path d="M23.5 35.8063C24.9372 35.8063 26.1022 34.6398 26.1022 33.201C26.1022 31.7621 24.9372 30.5957 23.5 30.5957C22.0629 30.5957 20.8978 31.7621 20.8978 33.201C20.8978 34.6398 22.0629 35.8063 23.5 35.8063Z" fill="#20242B" />
                <path d="M21.1505 26.3384L19.6635 16.2197C19.3518 14.0984 20.8167 12.1256 22.9355 11.8135C25.4593 11.3987 27.7428 13.703 27.3365 16.2197C27.3365 16.2197 25.8495 26.3384 25.8495 26.3384C25.4251 29.0345 21.5606 29.005 21.1505 26.3384Z" fill="#20242B" />
            </g>
            <defs>
                <clipPath id="clip0_267_161">
                    <rect width="47" height="42" fill="white" />
                </clipPath>
            </defs>
        </SvgIcon>
  )
}